import React, { useState } from 'react';

const DeleteConfirmation = ({
  onConfirm,
  onCancel,
  isDeleting = false,
  toEmails = [],
  ccEmails = [],
  isLoadingEmails = false,
}) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const isDisabled = !subject.trim() || !message.trim() || isDeleting || isLoadingEmails;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isDisabled) onConfirm({ subject, message });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-9 px-5 py-8 font-inter text-gray-50 sm:min-h-[610px] sm:gap-12 sm:px-10 sm:py-14">
      <div className="flex flex-wrap items-center gap-2 text-xl sm:text-2xl">
        <label htmlFor="delete-subject" className="font-medium">
          Sujet :
        </label>
        <input
          id="delete-subject"
          type="text"
          className="min-w-0 flex-1 bg-transparent py-1 text-gray-50 placeholder:text-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-10"
          value={subject}
          onChange={(event) => setSubject(event.target.value)}
          disabled={isDeleting || isLoadingEmails}
          placeholder="[Insérer un sujet]"
          required
        />
      </div>

      <div className="space-y-1 text-base sm:text-xl">
        <div className="flex flex-wrap gap-x-2">
          <span className="font-medium">Pour:</span>
          {isLoadingEmails ? (
            <span
              className="h-6 w-48 animate-pulse rounded bg-teal-10"
              aria-label="Chargement des destinataires"
            />
          ) : (
            <span className="break-all font-bold">{toEmails.join(', ') || '—'}</span>
          )}
        </div>
        {(isLoadingEmails || ccEmails.length > 0) && (
          <div className="flex flex-wrap gap-x-2">
            <span className="font-medium">CC:</span>
            {isLoadingEmails ? (
              <span
                className="h-6 w-48 animate-pulse rounded bg-teal-10"
                aria-label="Chargement des destinataires en copie"
              />
            ) : (
              <span className="break-all">{ccEmails.join(', ')}</span>
            )}
          </div>
        )}
      </div>

      <div>
        <label htmlFor="delete-message" className="mb-3 block text-lg font-bold sm:text-xl">
          Insérer un message
        </label>
        <textarea
          id="delete-message"
          placeholder="Insérer un message"
          className="min-h-[72px] w-full resize-y rounded-[22px] border-0 bg-teal-10 px-6 py-5 text-lg text-gray-50 placeholder:text-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-10 sm:px-10"
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          disabled={isDeleting || isLoadingEmails}
          required
        />
      </div>

      <p className="text-base text-[#C84E4B] sm:text-xl">
        <strong>Attention :</strong> Cette action supprimera définitivement toutes les données.
        Cette opération est irréversible.
      </p>

      <div className="mt-auto flex flex-wrap justify-end gap-4 pt-2">
        <button
          type="button"
          onClick={onCancel}
          disabled={isDeleting}
          className="min-h-[64px] rounded-[28px] border-2 border-blue-10 bg-white px-7 font-bold text-blue-10 transition-colors hover:bg-teal-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-10 disabled:cursor-not-allowed disabled:opacity-50 sm:px-9">
          ANNULER
        </button>
        <button
          type="submit"
          disabled={isDisabled}
          className="min-h-[64px] rounded-[28px] bg-blue-10 px-7 font-bold text-white transition-colors hover:bg-blue-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-10 disabled:cursor-not-allowed disabled:bg-gray-400 sm:px-9">
          {isDeleting ? 'Envoi en cours...' : 'SUPPRIMER ET ENVOYER'}
        </button>
      </div>
    </form>
  );
};

export default DeleteConfirmation;
